/**
 * @generated SignedSource<<21e46a76f57e96b2588677cecd741871>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserForgotAuthNameInput = {
  email: string;
};
export type authForgotUserAuthNameMutation$variables = {
  input: UserForgotAuthNameInput;
};
export type authForgotUserAuthNameMutation$data = {
  readonly forgotUserAuthName: boolean;
};
export type authForgotUserAuthNameMutation = {
  response: authForgotUserAuthNameMutation$data;
  variables: authForgotUserAuthNameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "forgotUserAuthName",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authForgotUserAuthNameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authForgotUserAuthNameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f06a1b4022f129515b627efe87f436cd",
    "id": null,
    "metadata": {},
    "name": "authForgotUserAuthNameMutation",
    "operationKind": "mutation",
    "text": "mutation authForgotUserAuthNameMutation(\n  $input: UserForgotAuthNameInput!\n) {\n  forgotUserAuthName(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "fca84c5748cd7261d798f7d36ed16ab2";

export default node;
